module.exports = __webpack_public_path__ + "6b8070818195a390b6352bfcee240242.png";